import {Component, Input, OnInit} from '@angular/core';
import { BaseModal } from 'src/app/core/utils/BaseModal';
import { ModalContent } from 'src/app/core/interface';
import {
  AlertService, LaneService,
  AppraisalService, SpotService,
  EquipmentModelService, UserService,
  EquipmentService, ManufacturerService,
  ModalService, AppraisalMeasurementsService
} from 'src/app/core/services';
import {
  AlertType, Appraisal, Equipment, EquipmentModel,
  Manufacturer, Spot, Lane, User, AppraisalMeasurements, AlertItem
} from 'src/app/core/models';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-appaisal-measurements-update',
  templateUrl: './appaisal-measurements-update.component.html',
  styleUrls: ['./appaisal-measurements-update.component.sass']
})
export class AppaisalMeasurementsUpdateComponent extends BaseModal implements OnInit, ModalContent {
  @Input() initialState;

  public isValid = false;
  public loading = true;
  public promise: Promise<any>;
  public appraisal: Appraisal = new Appraisal();
  public typeUnfoldEquipment = 'more';
  public typeUnfoldLocal = 'more';
  public typeUnfoldResponsible = 'more';
  public equipment: Equipment = new Equipment();
  public equipmentModel: EquipmentModel = new EquipmentModel();
  public manufacturer: Manufacturer = new Manufacturer();
  public spot: Spot = new Spot();
  public lane: Lane = new Lane();
  public user: User = new User();
  public appraisalMeasurements: Array<AppraisalMeasurements>;
  public appMeasurementsForm: FormGroup;
  public sizeMeasurements = 0;
  public situationEnd = '';

  constructor(
    public modalService: ModalService,
    private alertService: AlertService,
    private appraisalService: AppraisalService,
    private equipmentService: EquipmentService,
    private equipmentModelService: EquipmentModelService,
    private manufacturerService: ManufacturerService,
    private spotService: SpotService,
    private laneService: LaneService,
    private userService: UserService,
    private appraisalMeasurementsService: AppraisalMeasurementsService,
    private formBuilder: FormBuilder,
  ) {
    super(modalService);
  }

  ngOnInit(): void {
    this.appraisal = this.initialState as Appraisal || new Appraisal();
    this.getRelationship();
  }
  async getRelationship() {
    await this.appraisalMeasurementsService.list({ order: 'code', appraisalId: this.appraisal.id }).then(resList => {
      this.appraisalMeasurements = resList.result;
    });
    await this.equipmentService.getById(this.appraisal.equipment.id).then(response => {
      this.equipment = response;
    });
    await this.equipmentModelService.getById(this.equipment.equipmentModelId).then(response => {
      this.equipmentModel = response;
    });
    await this.manufacturerService.getById(this.equipmentModel.manufacturerId).then(response => {
      this.manufacturer = response;
    });
    await this.spotService.getById(this.appraisal.spotId).then(response => {
      this.spot = response;
    });
    await this.laneService.getById(this.appraisal.laneId).then(response => {
      this.lane = response;
    });
    await this.userService.list({ id: this.appraisal.technicianUserId + '' }).then(res => {
      this.user = res.result[0];
    });
    await this.createForm();
    this.loading = false;
  }
  createForm(): void {
    let book = false;
    let aprovalOrder = false;
    let measurementStandard = '';
    let calibrationLicence = '';
    if (this.appraisalMeasurements.length > 0) {
      book = this.appraisalMeasurements[0].modelAccordingToComponentBook ? true : false;
      aprovalOrder = this.appraisalMeasurements[0].modelAccordingToApprovalOrder ? true : false;
      measurementStandard =  this.appraisalMeasurements[0].measurementStandard;
      calibrationLicence =this.appraisalMeasurements[0].calibrationLicence;
    }
    this.appMeasurementsForm = this.formBuilder.group({
      modelAccordingToComponentBook: [book,[Validators.required]],
      modelAccordingToApprovalOrder: [aprovalOrder,[Validators.required]],
      measurementStandard: [measurementStandard, [Validators.required]],
      calibrationLicence: [calibrationLicence, [Validators.required]],
      measurements:  new FormBuilder().array([]),
    });
    this.appMeasurementsForm.valueChanges.subscribe(() => {
      this.isValid = this.appMeasurementsForm.valid;
    });
    if (this.appraisalMeasurements.length > 0) {
      for (const item of this.appraisalMeasurements) {
        this.addMeasurements(item);
      }
    }
  }
  get lastState(): any {
    throw new Error('Method not implemented.');
  }
  addMeasurements(item = null) {
    this.sizeMeasurements ++;
    let result  = 0;
    if (item && item.result) {
      result = item.result;
    }
    const measurementItem = this.formBuilder.group({
      id: [item?.id || null,],
      code: [item?.code || this.sizeMeasurements],
      standardSpeed: [item?.standardSpeed || ''],
      recordedSpeed: [item?.recordedSpeed || ''],
      maximumPermitted: [item?.maximumPermitted || '-/+ 5km/h'],
      result: [result, [Validators.required]],
      situation: [item?.situation || '', [Validators.required]]
    });
    (this.appMeasurementsForm.controls.measurements as FormArray).push(measurementItem);
    this.getSituationEnd();
  }
  removeMeasurements(idx) {
    const measurements = this.appMeasurementsForm.get('measurements') as FormArray;
    if (measurements.at(idx).get('id').value !== null) {
      this.appraisalMeasurementsService.delete(measurements.at(idx).get('id').value);
    }
    (this.appMeasurementsForm.controls.measurements as FormArray).removeAt(idx);
    this.sizeMeasurements --;
    let index = 0;
    while(index <= measurements.length) {
      measurements.at(index).get('code').setValue(index + 1);
      index++;
    }
  }
  public async onAllSubmited() {
    if (this.promise != null) {
      return this.promise;
    }
    const measurements = this.appMeasurementsForm.get('measurements') as FormArray;
    let data: any;
    this.situationEnd = this.sizeMeasurements === 10 ? this.situationEnd : '';
    for (const measurement of measurements.value) {
      data = {
        id: measurement.id,
        appraisalId: this.appraisal.id,
        contractId: this.appraisal.contractId,
        code: measurement.code,
        modelAccordingToComponentBook: this.appMeasurementsForm.get('modelAccordingToComponentBook').value,
        modelAccordingToApprovalOrder: this.appMeasurementsForm.get('modelAccordingToApprovalOrder').value,
        measurementStandard: this.appMeasurementsForm.get('measurementStandard').value,
        calibrationLicence: this.appMeasurementsForm.get('calibrationLicence').value,
        standardSpeed: Number(measurement.standardSpeed),
        recordedSpeed: Number(measurement.recordedSpeed),
        maximumPermitted: measurement.maximumPermitted,
        result: measurement.result,
        situation: measurement.situation,
        situationEnd: this.situationEnd,
      };
      if(!measurement.id) {
        delete data.id;
        this.promise = this.appraisalMeasurementsService.create(data);
      } else {
        this.promise = this.appraisalMeasurementsService.update(data);
      }
    }
    this.promise.then(res => {
      this.alertService.show(new AlertItem('AppraisalSaved', AlertType.success));
      return res;
    }).catch(error => {
      this.alertService.show(new AlertItem('AppraisalSaveError', AlertType.danger));
      throw error;
    }).finally(() => {
      this.promise = null;
    });
    return this.promise;
  }
  unfoldMoreOrLessEquipment() {
    this.typeUnfoldEquipment = this.typeUnfoldEquipment === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldEquipment`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }

  unfoldMoreOrLessLocal() {
    this.typeUnfoldLocal = this.typeUnfoldLocal === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldLocal`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }
  unfoldMoreOrLessResponsible() {
    this.typeUnfoldResponsible = this.typeUnfoldResponsible === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldLocal`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }
  getLabel(idx) {
    const measurements = this.appMeasurementsForm.get('measurements') as FormArray;
    return measurements.at(idx).get('situation').value;
  }
  getFormula(idx) {
    const measurements = this.appMeasurementsForm.get('measurements') as FormArray;
    return measurements.at(idx).get('maximumPermitted').value;
  }
  calculateResult(idx) {
    const measurements = this.appMeasurementsForm.get('measurements') as FormArray;
    const standardSpeed = measurements.at(idx).get('standardSpeed').value;
    const recordedSpeed = measurements.at(idx).get('recordedSpeed').value;
    if (!standardSpeed || !recordedSpeed) {
      measurements.at(idx).get('situation').setValue('');
      return;
    }
    const  result = recordedSpeed - standardSpeed;
    let situation = '';
    measurements.at(idx).get('result').setValue(result);
    if (result > -6 && result < 6) {
      situation = 'approved';
    } else {
      situation = 'failed';
    }
    measurements.at(idx).get('situation').setValue(situation);
    this.getSituationEnd();
  }
  getSituationEnd() {
    const measurements = this.appMeasurementsForm.get('measurements') as FormArray;
    for (const measurement of measurements.value) {
      if (measurement.situation === 'failed' || measurement.situation === '') {
        this.situationEnd = 'failed';
        return;
      } else {
        this.situationEnd = 'approved';
      }
    }
  }
}
